import { NavLink } from 'react-router-dom';
import { Button } from '@srichaitra/ui';

/**
 * In-application navigation.
 *
 * Wraps the router's NavLink so screens never import from react-router
 * directly — the router stays an implementation detail of this library, and
 * swapping it later is a change here rather than in every file that links
 * somewhere.
 *
 * Rendered as a Material UI button with the NavLink as its element, which gives
 * a real anchor (right-click, open in new tab, and keyboard behaviour all work)
 * with the theme's styling. The active state hangs off aria-current, which the
 * router sets — so the visual state and the announced state cannot drift apart.
 */
export function AppNavLink({ to, children, ...rest }) {
  return (
    <Button
      component={NavLink}
      to={to}
      variant="ghost"
      size="sm"
      sx={{
        color: 'text.secondary',
        '&[aria-current="page"]': {
          color: 'primary.main',
          bgcolor: 'action.selected'
        }
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
